<template>
  <v-container class="py-12">
    <v-row>
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">{{ page.title }}</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="breadcrumbs"></v-breadcrumbs>
          </div>
          <div class="button-group">
            <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="save"
              :loading="loading" v-if="page.isNew">Salvar</v-btn>
            <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
              to="/abastecimentos">Voltar</v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-form ref="form" v-model="validForm">
      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Responsável e veículo</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete dense outlined label="Motorista que informou"
                    :items="drivers"
                    :item-text="driverLabel"
                    item-value="id"
                    v-model="form.driver_id"
                    :search-input.sync="driverSearch"
                    :loading="driversLoading"
                    :rules="[$rules.required]"
                    :readonly="!page.isNew"
                    hide-details="auto"
                    clearable>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="8">
                  <v-autocomplete dense outlined label="Frota / veículo"
                    :items="vehicles"
                    :item-text="vehicleLabel"
                    item-value="code"
                    v-model="form.vehicle_number"
                    :search-input.sync="vehicleSearch"
                    :loading="vehiclesLoading"
                    :rules="[$rules.required]"
                    :readonly="!page.isNew"
                    hide-details="auto"
                    clearable>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined type="number" label="KM no abastecimento"
                    v-model="form.km" min="0" :rules="[$rules.required]"
                    :readonly="!page.isNew" hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="card-form-outlined">
            <v-card-title class="card-group-title">Abastecimento</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select dense outlined label="Combustível"
                    :items="fuelTypes"
                    v-model="form.fuel_type"
                    :rules="[$rules.required]"
                    :readonly="!page.isNew"
                    hide-details="auto"></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined label="Custo calculado" prefix="R$"
                    :value="calculatedCost" readonly hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined type="number" label="Valor do litro" prefix="R$"
                    v-model="form.unit_price" min="0" step="0.0001" :rules="[$rules.required]"
                    :readonly="!page.isNew" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined type="number" label="Litragem" suffix="L"
                    v-model="form.liters" min="0" step="0.001" :rules="[$rules.required]"
                    :readonly="!page.isNew" hide-details="auto"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined label="M³ calculado"
                    :value="calculatedCubicMeters" suffix="m³" readonly hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field dense outlined type="datetime-local" label="Data"
                    v-model="form.usage_date" :readonly="!page.isNew"
                    hide-details="auto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-file-input dense outlined show-size counter label="Foto do odômetro"
                    v-model="form.odometer_photo" accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-camera" :readonly="!page.isNew"
                    :rules="page.isNew ? [$rules.required] : []" hide-details="auto"></v-file-input>
                  <div v-if="form.odometer_photo_id" class="mt-3">
                    <private-image :id="form.odometer_photo_id" :size="120"></private-image>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <v-file-input dense outlined show-size counter label="Foto da nota fiscal"
                    v-model="form.invoice_photo" accept="image/png, image/jpeg, image/bmp"
                    prepend-icon="mdi-receipt" :readonly="!page.isNew"
                    :rules="page.isNew ? [$rules.required] : []" hide-details="auto"></v-file-input>
                  <div v-if="form.invoice_photo_id" class="mt-3">
                    <private-image :id="form.invoice_photo_id" :size="120"></private-image>
                  </div>
                </v-col>
              </v-row>
              <v-alert v-if="form.odometer_alert" dense outlined type="warning" class="mt-4">
                {{ form.odometer_alert_message || 'Abastecimento com alerta de intervalo de odômetro.' }}
              </v-alert>
              <v-row>
                <v-col cols="12">
                  <v-textarea dense outlined label="Descrição"
                    v-model="form.description" rows="3" auto-grow
                    :readonly="!page.isNew" hide-details="auto"></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SuppliesDetails',
  data: () => ({
    page: {
      title: '',
      isNew: true,
    },
    breadcrumbs: [],
    loading: false,
    validForm: true,
    driversLoading: false,
    vehiclesLoading: false,
    drivers: [],
    vehicles: [],
    driverSearch: '',
    vehicleSearch: '',
    fuelTypes: ['Gasolina', 'Etanol', 'Diesel', 'GNV', 'Flex'],
    form: {
      driver_id: null,
      vehicle_number: null,
      km: null,
      fuel_type: 'Gasolina',
      cost: null,
      unit_price: null,
      liters: null,
      cubic_meters: null,
      odometer_photo: null,
      invoice_photo: null,
      odometer_photo_id: null,
      invoice_photo_id: null,
      odometer_alert: false,
      odometer_alert_message: null,
      usage_date: null,
      description: '',
    },
  }),

  computed: {
    calculatedCostValue() {
      return this.toNumber(this.form.liters) * this.toNumber(this.form.unit_price)
    },

    calculatedCost() {
      return this.calculatedCostValue.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    calculatedCubicMeters() {
      const liters = this.toNumber(this.form.liters)
      return (liters / 1000).toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 6,
      })
    },
  },

  watch: {
    driverSearch(value) {
      this.loadDrivers(value)
    },

    vehicleSearch(value) {
      this.loadVehicles(value)
    },
  },

  created() {
    this.page.isNew = this.$route.params.id === 'novo'
    this.setPage()
    this.listBreadCrumbItems()
    this.loadVehicles()
    this.loadDrivers()

    if (!this.page.isNew) {
      this.load()
    } else {
      this.form.usage_date = this.dateToInput(new Date())
    }
  },

  methods: {
    setPage() {
      this.page.title = this.page.isNew ? 'Novo abastecimento' : 'Visualizar abastecimento'
    },

    listBreadCrumbItems() {
      this.breadcrumbs = [
        { text: 'Home', disabled: false, to: '/home', exact: true },
        { text: 'Abastecimentos', disabled: false, to: '/abastecimentos', exact: true },
        { text: this.page.isNew ? 'Novo abastecimento' : 'Visualizar abastecimento', disabled: true, exact: true },
      ]
    },

    vehicleLabel(item) {
      if (!item) return ''
      const plate = item.plate ? ` - ${item.plate}` : ''
      const model = item.model ? ` - ${item.model.brand || ''} ${item.model.model || ''}` : ''
      return `Frota ${item.code || '-'}${plate}${model}`
    },

    driverLabel(item) {
      if (!item) return ''
      const registration = item.registration ? ` - ${item.registration}` : ''
      const fullName = [item.name, item.last_name].filter(Boolean).join(' ')
      return `${fullName || 'Motorista'}${registration}`
    },

    dateToInput(value) {
      if (!value) return null
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return null
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
    },

    dateToSql(value) {
      if (!value) return null
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return null
      const pad = (n) => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },

    toNumber(value) {
      if (value === undefined || value === null || value === '') return 0
      const normalized = String(value).includes(',')
        ? String(value).replaceAll('.', '').replace(',', '.')
        : String(value)
      const number = Number(normalized)
      return Number.isFinite(number) ? number : 0
    },

    async loadVehicles(searchText = '') {
      this.vehiclesLoading = true
      try {
        const search = searchText ? JSON.stringify({ code: searchText }) : '{}'
        const { data } = await axios.get('/api/v2/vehicles', {
          params: { page: 1, limit: 30, search },
        })
        this.vehicles = data?.content?.data || []
      } catch (error) {
        this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar veículos.', {
          position: 'top-right',
          timeout: 5000,
        })
      } finally {
        this.vehiclesLoading = false
      }
    },

    async loadDrivers(searchText = '') {
      this.driversLoading = true
      try {
        const search = searchText ? JSON.stringify({ name: searchText }) : '{}'
        const { data } = await axios.get('/api/v2/drivers', {
          params: { page: 1, limit: 30, search },
        })
        this.drivers = data?.content?.data || []
      } catch (error) {
        this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar motoristas.', {
          position: 'top-right',
          timeout: 5000,
        })
      } finally {
        this.driversLoading = false
      }
    },

    async load() {
      this.loading = true
      try {
        const { data } = await axios.get(`/api/v2/fuel-supplies/${this.$route.params.id}`)
        const item = data?.content || {}

        this.form = {
          driver_id: item.driver_id || null,
          vehicle_number: item.vehicle_code || item.current_vehicle_code || null,
          km: item.odometer,
          fuel_type: item.fuel_type || 'Gasolina',
          cost: item.cost || item.total_value,
          unit_price: item.unit_price,
          liters: item.liters,
          cubic_meters: item.cubic_meters,
          odometer_photo: null,
          invoice_photo: null,
          odometer_photo_id: item.odometer_photo_id || null,
          invoice_photo_id: item.invoice_photo_id || null,
          odometer_alert: Boolean(item.odometer_alert),
          odometer_alert_message: item.odometer_alert_message || null,
          usage_date: this.dateToInput(item.usage_date),
          description: item.description || '',
        }

        if (item.driver_id && !this.drivers.find((driver) => driver.id === item.driver_id)) {
          this.drivers.push({
            id: item.driver_id,
            name: item.driver_name,
          })
        }

        if (item.vehicle_code && !this.vehicles.find((vehicle) => vehicle.code === item.vehicle_code)) {
          this.vehicles.push({
            code: item.vehicle_code,
            plate: item.plate || item.current_plate,
            model: { brand: item.brand, model: item.model },
          })
        }
      } catch (error) {
        this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao carregar abastecimento.', {
          position: 'top-right',
          timeout: 5000,
        })
        this.$router.replace('/abastecimentos')
      } finally {
        this.loading = false
      }
    },

    async uploadResource(file) {
      if (!file) return null

      const formData = new FormData()
      formData.append('file', file)
      const { data } = await axios.post('/api/v2/resources', formData)
      return data?.content?.id || null
    },

    async buildPayload() {
      const odometerPhotoId = await this.uploadResource(this.form.odometer_photo)
      const invoicePhotoId = await this.uploadResource(this.form.invoice_photo)

      return {
        driver_id: this.form.driver_id,
        vehicle_number: this.form.vehicle_number,
        km: this.toNumber(this.form.km),
        fuel_type: this.form.fuel_type,
        unit_price: this.toNumber(this.form.unit_price),
        liters: this.toNumber(this.form.liters),
        cubic_meters: this.toNumber(this.form.liters) / 1000,
        odometer_photo_id: odometerPhotoId,
        invoice_photo_id: invoicePhotoId,
        usage_date: this.dateToSql(this.form.usage_date),
        description: this.form.description || null,
      }
    },

    async save() {
      if (!this.$refs.form.validate()) return

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja salvar este abastecimento?',
        title: 'Salvar abastecimento',
        actions: { false: 'Cancelar', true: 'Salvar' },
      })

      if (!proceedAction) return

      this.loading = true

      try {
        await axios.post('/api/v2/fuel-supplies', await this.buildPayload())
        this.$dialog.notify.info('Abastecimento criado com sucesso.', { position: 'top-right', timeout: 2000 })
        this.$router.replace('/abastecimentos')
      } catch (error) {
        this.$dialog.notify.error(this.$codes ? this.$codes(error) : 'Erro ao salvar abastecimento.', {
          position: 'top-right',
          timeout: 5000,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
